import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constants } from '../../../shared/utilities/Constants';
import { EAuthClientsResponse } from '../../models/EAuthClients';
import { selectEAuthState } from '../../reducers';
import { selectHasAccessInitiateMoneyMovement } from '../../../authorize/reducers';
import { selectInfo } from '../../../account-info-header/reducers';


@Component({
  standalone: false,
    selector: 'mm-eAuthorization-page',
    templateUrl: './eAuthorization-page.component.html',
    styleUrls: ['./eAuthorization-page.component.scss']
})
export class EAuthorizationPageComponent implements OnInit, OnDestroy {
    eauthClientsResponse: EAuthClientsResponse;
    setupEAuthorizationSelected: boolean = true;
    destroy$ = new Subject<void>();
    accountTypeIneligibleForEAuth: boolean | undefined;
    hasEauthClientsServiceError: boolean = false;
    isInitRelease: boolean;
    regType: string;

    eAuthorizationTooltipText = Constants.eAuthorizationDescription;
    schwabAllianceTooltipText = Constants.schwabAllianceDescription;
    notSupportedErrorMessage = Constants.toAccountValidationError;

    constructor(private store: Store<{}>) { }

    ngOnInit(): void {
        this.store.select(selectEAuthState)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
            if (data.hasServiceError) {
                this.hasEauthClientsServiceError = true;
            } else {
                this.hasEauthClientsServiceError = false;
                this.eauthClientsResponse = data.eauthClients;
                this.accountTypeIneligibleForEAuth = data.eauthClients.isAccountRestricted;
            }
        });

        this.store.select(selectHasAccessInitiateMoneyMovement).pipe(takeUntil(this.destroy$)).subscribe(hasAccess => {
            this.isInitRelease = hasAccess;
        });

        this.store
            .select(selectInfo)
            .pipe(takeUntil(this.destroy$))
            .subscribe((info) => {
            this.regType = info.registrationType;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }

    get cannotDisplayAnyAccountHolders(): boolean {
        if (!this.eauthClientsResponse || !this.eauthClientsResponse.eauthClients || this.eauthClientsResponse.eauthClients.length <= 0) {
            return true;
        }
        for (var i = 0; i < this.eauthClientsResponse.eauthClients.length; i++) {
            if (this.eauthClientsResponse.eauthClients[i].displayIndicator) {
                return false;
            }
        }
        return true;
    }
}